import { request } from '../lib/http'

export function fetchAll () {
  return request({
    url: 'dashboard',
    method: 'get'
  })
}